const DEFAULT_STATUS = 'submitted'
const SUBMITTED_FOR_REVIEW = 'submitted'
const APPROVED = 'approved'
const REJECTED = 'rejected'
const UNENROLLED = 'unenrolled'

export { DEFAULT_STATUS, SUBMITTED_FOR_REVIEW, APPROVED, REJECTED, UNENROLLED }
